import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    icon: "/images/giveaway/how_it_works_icon1.svg",
    title: "מצטרפים",
    desc: "נרשמים לפלטפורמה ונכנסים לאקו-סיסטם של MOM3NTUM",
  },
  {
    num: "02",
    icon: "/images/giveaway/how_it_works_icon2.svg",
    title: "יוצרים\nמומנטום",
    desc: "לוקחים חלק בפעילויות הקהילה ובקמפיינים הייחודיים שלנו.",
  },
  {
    num: "03",
    icon: "/images/giveaway/how_it_works_icon3.svg",
    title: "נועלים גישה",
    desc: "מקבלים את הזכות המובטחת לרכוש כרטיס במחיר המקורי (Face Value).",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28" style={{ background: "#121212" }}>
      <div className="max-w-xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-bold text-white text-center mb-14"
          style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
        >
          איך זה עובד?
        </motion.h2>

        <div className="space-y-6">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="rounded-2xl px-4 py-6 overflow-hidden"
              style={{
                backgroundImage: `url('/images/giveaway/how_it_works_bg.png')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                className="grid items-center gap-x-3"
                style={{ gridTemplateColumns: "auto 1fr auto" }}
              >
                {/* Row 1: Number | Title | Icon */}
                <span
                  className="text-4xl font-bold"
                  style={{ color: "#D7FF37" }}
                >
                  {step.num}
                </span>
                <h3
                  className="text-xl font-bold whitespace-pre-line"
                  style={{ color: "#D7FF37" }}
                >
                  {step.title}
                </h3>
                <img src={step.icon} alt="" className="w-10 h-10" />

                {/* Row 2: _ | Description | _ */}
                <div />
                <p
                  className="text-base leading-relaxed pt-2"
                  style={{ color: "#FFFFFF" }}
                >
                  {step.desc}
                </p>
                <div />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
